import React, { createContext, useContext, useState, useCallback } from 'react';
import { NotificationType } from '../enums/NotificationType';

const NotificationContext = createContext();

// Custom hook for easy access to the context
export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotification must be used within a NotificationProvider");
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
    
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback(({ message, type = NotificationType.Info }) => {
    setNotification({ message, type });
  }, []);

  const clearNotification = useCallback(() => {
    setNotification(null);
  }, []);

  return (
    <NotificationContext.Provider value={{ notification, showNotification, clearNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};
